<template>
    <div class="main-page">
        <template v-if="showHeader">
            <section class="page-section mb-3" >
                <div class="container">
                    <div class="grid justify-content-between">
                        <div class="col " >
                            <div class="">
                                <div class=" text-2xl text-primary font-bold" >
                                    Add New App Info
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </template>
        <section class="page-section " >
            <div class="container">
                <div class="grid ">
                    <div class="md:col-9 sm:col-12 comp-grid" >
                        <div class="">
                            <div class="">
                                <div >
                                    <form ref="observer" tag="form" @submit.prevent="submitForm()" class="" :class="{ 'card': !isSubPage }">
                                        <div class="grid">
                                            <div class="col-12">
                                                <div class="formgrid grid">
                                                    <div class="col-12 md:col-3">
                                                        App Id *
                                                    </div>
                                                    <div class="col-12 md:col-9">
                                                        <InputText ref="ctrlapp_id" v-model.trim="formData.app_id"  label="App Id" type="text" placeholder="Enter App Id"      
                                                        class=" w-full" :class="getErrorClass('app_id')">
                                                        </InputText>
                                                        <small v-if="isFieldValid('app_id')" class="p-error">{{ getFieldError('app_id') }}</small> 
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-12">
                                                <div class="formgrid grid">
                                                    <div class="col-12 md:col-3">
                                                        App Version 
                                                    </div>
                                                    <div class="col-12 md:col-9">
                                                        <InputText ref="ctrlapp_version" v-model.trim="formData.app_version"  label="App Version" type="text" placeholder="Enter App Version"      
                                                        class=" w-full" :class="getErrorClass('app_version')">
                                                        </InputText>
                                                        <small v-if="isFieldValid('app_version')" class="p-error">{{ getFieldError('app_version') }}</small> 
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-12">
                                                <div class="formgrid grid">
                                                    <div class="col-12 md:col-3">
                                                        Min Android Version 
                                                    </div>
                                                    <div class="col-12 md:col-9">
                                                        <InputText ref="ctrlmin_android_version" v-model.trim="formData.min_android_version"  label="Min Android Version" type="text" placeholder="Enter Min Android Version"      
                                                        class=" w-full" :class="getErrorClass('min_android_version')">
                                                        </InputText>
                                                        <small v-if="isFieldValid('min_android_version')" class="p-error">{{ getFieldError('min_android_version') }}</small> 
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-12">
                                                <div class="formgrid grid">
                                                    <div class="col-12 md:col-3">
                                                        Min Ios Version 
                                                    </div>
                                                    <div class="col-12 md:col-9">
                                                        <InputText ref="ctrlmin_ios_version" v-model.trim="formData.min_ios_version"  label="Min Ios Version" type="text" placeholder="Enter Min Ios Version"      
                                                        class=" w-full" :class="getErrorClass('min_ios_version')">
                                                        </InputText>
                                                        <small v-if="isFieldValid('min_ios_version')" class="p-error">{{ getFieldError('min_ios_version') }}</small> 
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-12">
                                                <div class="formgrid grid">
                                                    <div class="col-12 md:col-3">
                                                        Byforce Update *
                                                    </div>
                                                    <div class="col-12 md:col-9">
                                                        <Calendar :showButtonBar="true" :showTime="true" dateFormat="yy-mm-dd" hourFormat="24" v-model="formData.byforce_update" :showIcon="true" class="w-full" :class="getErrorClass('byforce_update')"     mask="yy-MM-DD HH:mm"     />
                                                        <small v-if="isFieldValid('byforce_update')" class="p-error">{{ getFieldError('byforce_update') }}</small> 
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-12">
                                                <div class="formgrid grid">
                                                    <div class="col-12 md:col-3">
                                                        Maintenance Break *
                                                    </div>
                                                    <div class="col-12 md:col-9">
                                                        <InputText ref="ctrlmaintenance_break" v-model.trim="formData.maintenance_break"  label="Maintenance Break" type="text" placeholder="Enter Maintenance Break"      
                                                        class=" w-full" :class="getErrorClass('maintenance_break')">
                                                        </InputText>
                                                        <small v-if="isFieldValid('maintenance_break')" class="p-error">{{ getFieldError('maintenance_break') }}</small> 
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-12">
                                                <div class="formgrid grid">
                                                    <div class="col-12 md:col-3">
                                                        Enable Payment *
                                                    </div>
                                                    <div class="col-12 md:col-9">
                                                        <InputText ref="ctrlenable_payment" v-model.trim="formData.enable_payment"  label="Enable Payment" type="text" placeholder="Enter Enable Payment"      
                                                        class=" w-full" :class="getErrorClass('enable_payment')">
                                                        </InputText>
                                                        <small v-if="isFieldValid('enable_payment')" class="p-error">{{ getFieldError('enable_payment') }}</small> 
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-12">
                                                <div class="formgrid grid">
                                                    <div class="col-12 md:col-3">
                                                        Payment Percentage Charge 
                                                    </div>
                                                    <div class="col-12 md:col-9">
                                                        <InputText ref="ctrlpayment_percentage_charge" v-model.trim="formData.payment_percentage_charge"  label="Payment Percentage Charge" type="number" placeholder="Enter Payment Percentage Charge"   step="0.1"    
                                                        class=" w-full" :class="getErrorClass('payment_percentage_charge')">
                                                        </InputText>
                                                        <small v-if="isFieldValid('payment_percentage_charge')" class="p-error">{{ getFieldError('payment_percentage_charge') }}</small> 
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="showSubmitButton" class="text-center my-3">
                                            <Button class="p-button-primary" type="submit" label="Submit" icon="pi pi-send" :loading="saving" />
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script setup>
	import {  computed,  reactive, toRefs, onMounted } from 'vue';
	import useVuelidate from '@vuelidate/core';
	import { required, numeric, } from '@/services/validators';
	import { useApp } from '@/composables/app.js';
	import { useAddPage } from '@/composables/addpage.js';
	const props = defineProps({
		pageName : {
			type : String,
			default : 'app_info',
		},
		routeName : {
			type : String,
			default : 'app_infoadd',
		},
		apiPath : {
			type : String,
			default : 'app_info/add',
		},
		submitButtonLabel: {
			type: String,
			default: "Submit",
		},
		formValidationError: {
			type: String,
			default: "Form is invalid",
		},
		formValidationMsg: {
			type: String,
			default: "Please complete the form",
		},
		msgAfterSave: {
			type: String,
			default: "Record added successfully",
		},
		showHeader: {
			type: Boolean,
			default: true,
		},
		showSubmitButton: {
			type: Boolean,
			default: true,
		},
		redirect: {
			type : Boolean,
			default : true,
		},
		isSubPage: {
			type : Boolean,
			default : false,
		},
		pageData: { // use to set formData default values from another page
			type: Object,
			default: () => {} 
		},
	});
	const app = useApp();
	const formDefaultValues = {
		app_id: "", 
		app_version: "", 
		min_android_version: "", 
		min_ios_version: "", 
		byforce_update: "false", 
		maintenance_break: "false", 
		enable_payment: "true", 
		payment_percentage_charge: "", 
	};
	const formData = reactive({ ...formDefaultValues });
	//form validation rules
	const rules = computed(() => {
		return {
			app_id: { required },
			app_version: {  },
			min_android_version: {  },
			min_ios_version: {  },
			byforce_update: { required },
			maintenance_break: { required },
			enable_payment: { required },
			payment_percentage_charge: { numeric }
		}
	});
	const v$ = useVuelidate(rules, formData); // form validation
	const page = useAddPage({ props, formData, v$, beforeSubmit, afterSubmit });
	// perform custom validation before submit form
	// set custom form fields
	// return false if validation fails
	function beforeSubmit(){
		return true;
	}
	// after form submited to api
	// reset form data.
	// redirect to another page
	function afterSubmit(response) {
		app.flashMsg(props.msgAfterSave);
		page.setFormDefaultValues(); //reset form data
		if(props.redirect) app.navigateTo(`/app_info`);
	}
	//page state
	const {
		submitted, // form submitted state - Boolean
		saving, // form api submiting state - Boolean
		pageReady, // if api data loaded successfully
	} = toRefs(page.state);
	//page methods
	const {
		submitForm, //submit form data to api
		getErrorClass, // return error class if field is invalid- args(fieldname)
		getFieldError, //  get validation error message - args(fieldname)
		isFieldValid, // check if field is validated - args(fieldname)
		 // map api datasource  to Select options label-value
	} = page.methods;
	onMounted(()=>{
		const pageTitle = "Add New App Info";
		app.setPageTitle(props.routeName, pageTitle); // set browser page title
	});
	// expose page object for other components access
	defineExpose({
		page
	});
</script>
<style scoped>
</style>
